<script>
import ModelCreate from '@/components/models/create';
import FormsModel from "@/components/forms/model";
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Models",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelCreate
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('models.singular')) }},
    resourceRoute: {default: 'models'},
    modelVariable: {default: 'model'},
    form: {default() { return FormsModel; }}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('models.plural')),
      items: [
        {
          text: this.lodash.upperFirst(this.$t('models.plural')),
          href: "/models",
        },
        {
          text: this.$t("Create New"),
          href: "/models/create",
          active: true,
        },
      ],
      loading: false,
      storing: false,
      model: {
        ...this.$route.query
      },
      errors: {},
      alerts: [],
    }
  },
  methods: {
    setAlerts(alerts) {
      this.alerts = alerts
    },
    getModelKey(value) {
      return value[this.modelKey || 'id'];
    },
    getModelName(value) {
      return value['name'] || this.getModelKey(value)
    },
    handleModelChanged(event){
      this.isEditing = event;
    },
    handleBack() {
      this.$router.back()
    },
    failedAlert(error) {
      if (error.response && error.response.status === 422) {
        this.errors = (error.response.data || {}).errors;
        const key = Object.keys(this.errors).find((k) => this.errors[k].length)
        const errorMessage = key && this.errors[key][0]
        return Swal.fire({
          title: this.$t('Failed') + '!',
          text: errorMessage || (error.response && (error.response.data || {}).message) || error.message,
          type: 'danger',
          confirmButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false
        })
      }
      return Swal.fire({
        title: this.$t('Failed') + '!',
        text: (error.response && (error.response.data || {}).message) || error.message,
        type: 'danger',
        confirmButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false
      })
    },
    storeSuccessAlert(something) {
      return Swal.fire({
        title: this.$t('Success') + '!',
        text: this.$t(`You've added {something}`, {something}),
        type: 'success',
        showConfirmButton: false,
        timer: 1500
      })
    },
    store(value) {
      return Promise.resolve({ data: value })
    },
    handleStore(value) {
      this.storing = true;
      this.store(value)
        .then(() => this.storeSuccessAlert(this.getModelName(value)))
        .then(() => {
          this.isEditing = false;
          return this.$router.back()
        })
        .catch((error) => this.failedAlert(error))
        .finally(() => { this.storing = false })
    },
    preventNav() {
      if (this.isEditing) {
        return this.$t("All unsaved data will be lost. Are you sure?");
      }
      return null
    },
    handleBeforeRouteLeave(to, from, next) {
      if (this.isEditing) {
        if (!window.confirm(this.lodash.upperFirst(this.$t("All unsaved data will be lost. Are you sure?")))) {
          return;
        }
      }
      next();
    }
  },
  beforeMount() {
    window.onbeforeunload = this.preventNav
  },
  beforeDestroy() {
    window.onbeforeunload = null
  },
  beforeRouteLeave(to, from, next) {
    this.handleBeforeRouteLeave(to, from, next)
    // if (this.isEditing) {
    //   if (!window.confirm(this.lodash.upperFirst(this.$t("All unsaved data will be lost. Are you sure?")))) {
    //     return;
    //   }
    // }
    // next();
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <model-create
          class="col-12"
          :loading="loading"
          :storing="storing"
          v-bind="$props"
          v-model="model"
          :errors.sync="errors"
          @back-click="handleBack"
          @store-click="handleStore"
          @model-changed="handleModelChanged"
          :alerts="alerts"
          @set-alerts="setAlerts"
      >
      </model-create>
    </div>
  </Layout>
</template>
